import { getIcon } from './helpers';
import './styles.scss';

const JobLabels = ({ data }) => (
    <div className="job-labels">
        {data.map((label, index) => (
            <div key={index} className="job-label body3">
                {getIcon(label.type)}
                <div>{label.text}</div>
            </div>
        ))}
    </div>
);

export default JobLabels;
